
import React from 'react';
import { Link } from 'office-ui-fabric-react/lib/Link';


const ToolLink = ({toolItem, parItem}) => {

    const handleClick = () => {
        if (toolItem.handler) {
            toolItem.handler(parItem);
        }
    }

    return (
        <Link onClick={handleClick} >{toolItem.title}</Link>
    );
}

export default ToolLink;
